import React from 'react';
import { Stack } from '@global-ecom/nitro-uds/elements';
import { tw } from 'twind';

import { Product } from '__generated__/graphql';
import { resizeProductImage } from 'utils/image';
import { usePageEventsContext } from 'hooks/usePageEventsContext';
import { event, AnalyticsEvents } from 'utils/analytics';

import { Img } from '../../Img';

export const GWPNew_ProductSelector = ({
  setCurrentItem,
  currentItem,
  items,
}: {
  setCurrentItem: (product: Product) => void;
  currentItem: Product;
  items: Product[];
}) => {
  const { pageviewEventHasFired } = usePageEventsContext();

  const triggerEventSelectProductOverlay = (product: Product | undefined) => {
    if (pageviewEventHasFired) {
      event(AnalyticsEvents.GA4_CustomEvent, {
        event_name: AnalyticsEvents.GA4_SELECT_PRODUCT_OVERLAY,
        event_params: {
          item_id_ep: product?.variations[0]?.id,
          item_name_ep: product?.name,
        },
      });
    }
  };
  return (
    <Stack direction="inline" gap="xs" className="justify-center my-4">
      {items.map(product => {
        const productImage = product.variations[0].images[0];
        const isCurrentItem = product.id === currentItem?.id;

        return (
          <div
            key={product.id}
            className="w-16 flex-none transform-gpu"
            data-test-id="product-selector-gwp-modal"
          >
            <Img
              src={resizeProductImage(productImage.href, 128, '2000')}
              alt={productImage.alt ?? ''}
              title={productImage.alt}
              className={tw([
                isCurrentItem && 'border border-puma-black-200 rounded-sm',
              ])}
              onClick={() => {
                setCurrentItem(product);
                triggerEventSelectProductOverlay(product);
              }}
            />
          </div>
        );
      })}
    </Stack>
  );
};
